import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useWrapper = makeStyles<{ rewardsPresent?: boolean }>()(
  ({ shape, spacing, palette, breakpoints }: Theme, { rewardsPresent }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      height: '100%',
      backgroundColor: palette.background.default,
      overflow: 'scroll',
      padding: spacing(0, 2),

      [breakpoints.up('sm')]: {
        borderTopRightRadius: spacing(1),
        borderTopLeftRadius: spacing(1),
      },
      [breakpoints.down('md')]: {
        padding: spacing(0),
      },
    },
    titleBox: {
      padding: spacing(3, 0),
      [breakpoints.down('md')]: {
        backgroundColor: palette.background.default,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
        padding: spacing(1, 0, 0, 2),
        paddingBottom: rewardsPresent ? 0 : spacing(1),
      },
    },
    tabIndicator: {
      backgroundColor: palette.proceed.main,
    },
    mobileH4: {
      [breakpoints.down('md')]: {
        fontSize: 24,
      },
    },
    card: {
      [breakpoints.up('sm')]: {
        backgroundColor: palette.background.default,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
      },
      padding: spacing(2, 1.5),
      marginBottom: spacing(3),
      borderRadius: shape.borderRadius,
    },
    rightCard: {
      flexBasis: '100%',
      [breakpoints.up('md')]: {
        marginLeft: spacing(2),
      },
    },
    container: {
      display: 'flex',
    },
  })
);
